<script>
  // @ts-check
  import { createEventDispatcher } from "svelte";
  import Icon from "../../atoms/Icon.svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /** Search query text
   * @type {string} */
  export let query;

  /** Search suggested items list
   * @type {Array<string>} */
  export let items = [];

  /** Selected item
   * @type {string} */
  export let selectedItem = null;

  /** @type { string } */
  let componentClass = "";
  export { componentClass as class };

  const dispatch = createEventDispatcher();

  const onItemSelect = (item) => {
    dispatch("querySuggestionItemSelect", item);
  };
</script>

<ul
  {id}
  class="flex list-none flex-col gap-[20px] md:flex-row md:items-center lg:gap-[30px] {componentClass}"
>
  {#each items as item}
    {@const isSelected = selectedItem === item}
    <li>
      <button
        aria-label={item}
        class="group flex items-center gap-2 outline-offset-2 outline-black focus-visible:outline-dashed"
        on:click={() => onItemSelect(item)}
      >
        <Icon
          iconClass="{isSelected
            ? 'text-cobalt-blue'
            : 'text-black'} h-4 w-4 group-hover:text-cobalt-blue group-focus-visible:text-cobalt-blue"
          name="search"
        />
        <div class="flex flex-row gap-1">
          {#each item.split(" ") as word}
            {@const isQueryWord = query === word}
            {@const wordTextColor = isSelected
              ? "text-cobalt-blue"
              : isQueryWord
                ? "text-black"
                : "text-dark-grey"}
            <span
              aria-hidden={true}
              class="label {wordTextColor} group-hover:text-cobalt-blue group-focus-visible:text-cobalt-blue"
            >
              {word}{" "}
            </span>
          {/each}
        </div>
      </button>
    </li>
  {/each}
</ul>
